import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { Router } from '@angular/router'
import { TimerComponent } from '@app-ui/components/timer/timer.component'

import { HeadingDirective, ParagraphDirective } from '@app-ui/directives'
import { DefaultLayoutComponent } from '@app-ui/layouts'

@Component({
    selector: 'app-success',
    imports: [
        HeadingDirective,
        MatIcon,
        DefaultLayoutComponent,
        TimerComponent,
        ParagraphDirective,
    ],
    templateUrl: './success-page.component.html',
    styleUrl: './success-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class SuccessPageComponent {

    constructor(
        private readonly router: Router,
    ) {
        //
    }

    public async returnToStart(): Promise<void> {
        await this.router.navigate(['/'])
    }

}
